import { ACCESS, NOTIFICATION, SERVICE, KEY } from './action-constants';

// Requests
export const accessFiltersSelector = state => state.requests[ACCESS].filters;
export const accessRequestsSelector = state => state.requests[ACCESS].data;
export const accessLoadingSelector = state => state.requests[ACCESS].isLoading;
export const accessTotalSelector = state => state.requests[ACCESS].total;

export const serviceFiltersSelector = state => state.requests[SERVICE].filters;
export const serviceRequestsSelector = state => state.requests[SERVICE].data;
export const serviceLoadingSelector = state => state.requests[SERVICE].isLoading;
export const serviceTotalSelector = state => state.requests[SERVICE].total;

export const keyFiltersSelector = state => state.requests[KEY].filters;
export const keyRequestsSelector = state => state.requests[KEY].data;
export const keyLoadingSelector = state => state.requests[KEY].isLoading;
export const keyTotalSelector = state => state.requests[KEY].total;

export const ticketNumberFilter = (state, requestType) => state.requests[requestType].filters.ticketNumber;
export const customerFilter = (state, requestType) => state.requests[requestType].filters.customer;
export const dataCentreFilter = (state, requestType) => state.requests[requestType].filters.dataCentre;
export const siteVisitorFilter = (state, requestType) => state.requests[requestType].filters.siteVisitors;
export const additionalVisitorFilter = (state, requestType) => state.requests[requestType].filters.additionalVisitors;
export const accessZonesFilter = (state, requestType) => state.requests[requestType].filters.accessZones;
export const createdDateFilter = (state, requestType) => state.requests[requestType].filters.createdDate;
export const createdDateStartFilter = (state, requestType) => state.requests[requestType].filters.createdDate.start;
export const createdDateEndFilter = (state, requestType) => state.requests[requestType].filters.createdDate.end;
export const fromDateFilter = (state, requestType) => state.requests[requestType].filters.fromDate;
export const fromDateStartFilter = (state, requestType) => state.requests[requestType].filters.fromDate.start;
export const fromDateEndFilter = (state, requestType) => state.requests[requestType].filters.fromDate.end;
export const toDateFilter = (state, requestType) => state.requests[requestType].filters.toDate;
export const toDateStartFilter = (state, requestType) => state.requests[requestType].filters.toDate.start;
export const toDateEndFilter = (state, requestType) => state.requests[requestType].filters.toDate.end;
export const statusFilter = (state, requestType) => state.requests[requestType].filters.status;
export const airtrunkAccessNumberFilter = (state, requestType) => state.requests[requestType].filters.airtrunkAccessNumber;
export const accessReasonFilter = (state, requestType) => state.requests[requestType].filters.accessReason;

export const requestNumberFilter = (state, requestType) => state.requests[requestType].filters.ticketNumber;
export const keyStatusFilter = (state, requestType) => state.requests[requestType].filters.status;
export const requesterFilter = (state, requestType) => state.requests[requestType].filters.requester;
export const keyLockerFilter = (state, requestType) => state.requests[requestType].filters.keys;
export const dateInStartFilter = (state, requestType) => state.requests[requestType].filters.checkedInDate.start;
export const dateInEndFilter = (state, requestType) => state.requests[requestType].filters.checkedInDate.end;
export const dateOutStartFilter = (state, requestType) => state.requests[requestType].filters.checkedOutDate.start;
export const dateOutEndFilter = (state, requestType) => state.requests[requestType].filters.checkedOutDate.end;

export const sortSelector = (state, requestType) => state.requests[requestType].sort;

export const accessContactsSelector = state => state.requests[ACCESS].contacts.data;
export const accessContactsLoadingSelector = state => state.requests[ACCESS].contacts.isLoading;
export const accessContactsLoadedSelector = state => state.requests[ACCESS].contacts.isLoaded;

// Data - Drawer item
export const drawerIdSelector = state => state.data.drawerId;
export const drawerItemSelector = state => state.data.drawerItem;

// Data - Customer
export const customersSelector = state => state.data.customers.data;
export const customersLoadingSelector = state => state.data.customers.isLoading;
export const customersLoadedSelector = state => state.data.customers.isLoaded;

// Data - Data Centres
export const dataCentresSelector = state => state.data.dataCentres.data;
export const dataCentresLoadingSelector = state => state.data.dataCentres.isLoading;
export const dataCentresLoadedSelector = state => state.data.dataCentres.isLoaded;

// App
export const authStateSelector = state => state.app.authState;
export const notificationsSelector = state => state.app.notifications;
export const dashboardNotificationsSelector = state => state.requests.dashBoardNotificationType;
export const dashboardSelector = state => state.app.dashboard;

// Statuses
export const statusesLoadingSelector = state => state.statuses.isLoading;
export const accessStatusSelector = state => state.statuses[ACCESS];
export const serviceStatusSelector = state => state.statuses[SERVICE];
export const notificationStatusSelector = state => state.statuses[NOTIFICATION];
export const keyStatusSelector = state => state.statuses[KEY];
